import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import { Button, Typography, Checkbox, FormControl, FormControlLabel } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';


const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    observTextField: {
        display: 'flex',
        height: '100%',
        margin: theme.spacing(1),
    },
    inputObserv: {
        display: 'flex',
        alignItems: 'start',
        margin: '15px 0',
        padding: '5px 8px',

    },
    button: {
        margin: '15px 15px 15px 0',
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
    title: {
        marginTop: theme.spacing(1),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        marginBottom: theme.spacing(3),
    },
    formControl: {
        margin: theme.spacing(1),
    }
});

class EditIncidencia extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            incidencia: {},
            incidenciaText: '',
            diagnosticoText: '',
            resolucionText: '',
            status: 0,
            desactivar: false
        };
    }

    componentDidMount = () => {
        let status = 0;
        if (this.props.incidencia.usuarioIncidencia !== null) status = 1;
        if (this.props.incidencia.usuarioDiagnostico !== null) status = 2;
        if (this.props.incidencia.usuarioResolucion !== null) status = 3;
        this.setState({
            incidencia: this.props.incidencia,
            incidenciaText: this.props.incidencia.incidencia,
            diagnosticoText: this.props.incidencia.diagnostico,
            resolucionText: this.props.incidencia.resolucion,
            status: status,
            desactivar: (status === 0 && this.props.maquina.activa) || !this.props.maquina.activa
        });
    }

    handleValueChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.value })
    }


    handleCheckboxChange = (event) => {
        this.setState({ ...this.state, desactivar: event.target.checked });
    };

    render() {

        const { classes } = this.props;

        return (
            <div>

                <Typography variant="h4" color='secondary' className={classes.title}>{this.props.maquina.descr + ' - ' + this.props.maquina.regInterno}</Typography>

                <Typography variant="subtitle2">Incidencia</Typography>
                <TextField
                    className={classes.observTextField}
                    disabled={this.state.status !== 0}
                    placeholder={'Incidencia'}
                    InputProps={{
                        className: classes.inputObserv,
                    }}
                    id={'observDescuadre'}
                    value={this.state.incidenciaText}
                    variant='outlined'
                    multiline
                    rowsMax='5'
                    rows='5'
                    onChange={(event) => this.handleValueChange(event, 'incidenciaText')}
                />

                <FormControl className={classes.formControl}>
                    <FormControlLabel className={classes.labelCheck}
                        control={
                            <Checkbox
                                disabled={this.state.status !== 0}
                                checked={this.state.desactivar}
                                onChange={event => this.handleCheckboxChange(event)}
                                color="primary"
                            />
                        }
                        label={'Desactivar máquina'}
                    />
                </FormControl>


                <Typography variant="subtitle2">Diagnóstico</Typography>
                <TextField
                    className={classes.observTextField}
                    disabled={this.state.status !== 0 && this.state.status !== 1}
                    placeholder={'Diagnóstico'}
                    InputProps={{
                        className: classes.inputObserv,
                    }}
                    id={'observDescuadre'}
                    value={this.state.diagnosticoText}
                    variant='outlined'
                    multiline
                    rowsMax='5'
                    rows='5'
                    onChange={(event) => this.handleValueChange(event, 'diagnosticoText')}
                />

                <Typography variant="subtitle2">Resolución</Typography>
                <TextField
                    className={classes.observTextField}
                    disabled={this.state.status === 3 || !this.state.diagnosticoText}
                    placeholder={'Resolución'}
                    InputProps={{
                        className: classes.inputObserv,
                    }}
                    id={'observDescuadre'}
                    value={this.state.resolucionText}
                    variant='outlined'
                    multiline
                    rowsMax='5'
                    rows='5'
                    onChange={(event) => this.handleValueChange(event, 'resolucionText')}
                />

                <div className={classes.bottomBtn}>
                    <Button variant="contained" color="secondary" className={classes.button} onClick={() => { this.props.hideDialog() }}>Cerrar</Button>
                    <Button variant="contained" color="primary" className={classes.button}
                        disabled={(this.state.status === 0 && this.state.incidenciaText === '') || (this.state.status === 0 && this.state.resolucionText !== '' && this.state.diagnosticoText === '')
                            || (this.state.status === 1 && this.state.diagnosticoText === '') || (this.state.status === 2 && this.state.resolucionText === '')}
                        onClick={() => {
                            this.props.hideDialog();
                            this.props.okHandler({
                                id: this.props.incidencia.id,
                                maquinaId: this.props.incidencia.maquinaId,
                                fecha: this.props.incidencia.fecha,
                                incidencia: this.state.incidenciaText,
                                usuarioIncidencia: this.state.status === 0 ? this.props.user : this.props.incidencia.usuarioIncidencia,
                                fechaDiagnostico: this.state.status === 1 ? new Date().toISOString() : this.props.incidencia.fechaDiagnostico,
                                diagnostico: this.state.diagnosticoText,
                                usuarioDiagnostico: (this.state.status === 1 || (this.state.status === 0 && this.state.diagnosticoText !== '')) ? this.props.user : this.props.incidencia.usuarioDiagnostico,
                                fechaResolucion: this.state.status !== 3 && this.state.diagnosticoText !== '' && this.state.resolucionText !== '' ? new Date().toISOString() : this.props.incidencia.fechaResolucion,
                                resolucion: this.state.resolucionText,
                                usuarioResolucion: this.state.status !== 3 && this.state.diagnosticoText !== '' && this.state.resolucionText !== '' ? this.props.user : this.props.incidencia.usuarioResolucion
                            }, this.state.desactivar && (this.state.diagnosticoText === '' || this.state.resolucionText === ''));
                        }}>Guardar</Button>
                </div>

            </div>
        )

    }


}

EditIncidencia.propTypes = {

    //dispatch
    hideDialog: PropTypes.func.isRequired,

    //parameters
    okHandler: PropTypes.func.isRequired,
    incidencia: PropTypes.object.isRequired,
    maquina: PropTypes.object.isRequired,
    user: PropTypes.number.isRequired

};



export default withStyles(styles, { withTheme: true })(EditIncidencia);